// import React, { useEffect, useState } from "react";
// // import { supabase } from "../supabaseClient";
// import supabase from "../supabaseClient";
// import { useParams } from "react-router-dom";

// export default function BlogDetails() {
//   const { slug } = useParams();
//   const [blog, setBlog] = useState(null);

//   const fetchBlog = async () => {
//     const { data } = await supabase
//       .from("blogs")
//       .select("*")
//       .eq("slug", slug)
//       .single();
//     setBlog(data);
//   };

//   useEffect(() => {
//     fetchBlog();
//   }, [slug]);

//   if (!blog) return <p className="p-10 text-center">Loading...</p>;

//   return (
//     <div className="max-w-4xl mx-auto px-6 py-10">
//       <img
//         src={blog.banner_url}
//         alt=""
//         className="w-full h-80 object-cover rounded-lg shadow"
//       />
//       <h1 className="text-4xl font-bold mt-6 mb-3">{blog.title}</h1>
//       <p className="text-gray-500 mb-6">
//         {new Date(blog.created_at).toLocaleDateString()}
//       </p>
//       <p className="text-lg leading-relaxed whitespace-pre-wrap">{blog.content}</p>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import supabase from "../supabaseClient";
import { useParams } from "react-router-dom";

export default function BlogDetails() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      const { data } = await supabase
        .from("blogs")
        .select("*")
        .eq("slug", slug)
        .single();
      setBlog(data);
    };

    fetchBlog();
  }, [slug]);

  if (!blog) return <p className="p-10 text-center">Loading...</p>;

  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      {/* Banner */}
      {blog.banner_url && (
        <img
          src={blog.banner_url}
          alt="banner"
          className="w-full h-80 object-cover rounded-lg shadow"
        />
      )}

      {/* Title */}
      <h1 className="text-4xl font-bold mt-6 mb-3">{blog.title}</h1>

      {/* Date */}
      <p className="text-gray-500 mb-6">
        {new Date(blog.created_at).toLocaleDateString("en-IN", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>

      {/* Blog Content (HTML Rendered) */}
      <div
        className="text-lg leading-relaxed prose max-w-none"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      ></div>
    </div>
  );
}
